/**
 * Texte ou titre qu'on vient de déposer depuis la palette : son éditeur prend
 * le curseur dès qu'il se monte, pour écrire sans cliquer dedans.
 *
 * La demande survit à un premier montage : une box lâchée à la racine se
 * monte, puis se remonte dans le Bloc créé pour elle (cf. PuckPageEditor) —
 * c'est le second éditeur qui doit garder le curseur. Elle expire vite et
 * tombe à la première frappe, pour ne jamais reprendre le curseur ensuite.
 */
const TEXT_BLOCK_TYPES = new Set(['ProposalRichText', 'ProposalTitle']);
const REQUEST_TTL_MS = 2000;

let request = null;

export function requestDroppedTextFocus(action) {
  if (action?.type !== 'insert' || !action.id || !TEXT_BLOCK_TYPES.has(action.componentType)) return;
  request = { id: action.id, expiresAt: Date.now() + REQUEST_TTL_MS };
}

export function isDroppedTextFocusRequested(id) {
  return !!request && request.id === id && Date.now() < request.expiresAt;
}

export function clearDroppedTextFocus(id) {
  if (request?.id === id) request = null;
}
